<template>
  <div class="content">
    <div class="nav " :class=" {nav_top:scrollTop}">
      <div class="logo_box">
        <img src="../assets/logo.png" alt="" v-if="!scrollTop">
        <img src="../assets/LOGO_hei.png" v-else alt="">
      </div>
      <div class="nav_content">
        <ul>
          <li class="item " @click="goTo('Home')"><span>HOME</span></li>
          <li class="item ours ">
            <span class="navActive" v-if="lang=='en'">OUR PRODUCTS</span>
            <span class="navActive" v-if="lang=='it'">NOSTRI PRODOTTI</span>
            <div class="our" v-if="lang=='en'">
              <div class="items " @click="goTo('Bodys')"><span :class="{ourActive:productDataType=='body'}">BODY LOTION</span></div>
              <div class="items" @click="goTo('Sham')"><span :class="{ourActive:productDataType=='sham'}">SHAMPOO</span></div>
              <div class="items" @click="goTo('Bath')"><span :class="{ourActive:productDataType=='bath'}"> BATH & SHOWER GEL</span></div>
            </div>
            <div class="our" v-if="lang=='it'">
              <div class="items " @click="goTo('Bodys')"><span :class="{ourActive:productDataType=='body'}">CREMA CORPO</span></div>
              <div class="items" @click="goTo('Sham')"><span :class="{ourActive:productDataType=='sham'}">SHAMPOO</span></div>
              <div class="items" @click="goTo('Bath')"><span :class="{ourActive:productDataType=='bath'}"> BAGNO DOCCIA</span></div>
            </div>
          </li>
          <li class="item" @click="goTo('Story')" v-if="lang=='en'"><span>STORY & HISTORY</span></li>
          <li class="item" @click="goTo('Story')"  v-if="lang=='it'"><span>STORIA</span></li>
          <li class="item" @click="goTo('Contact')" v-if="lang=='en'"><span >CONTACT US</span></li>
          <li class="item" @click="goTo('Contact')" v-if="lang=='it'"><span >CONTATTACI</span></li>
        </ul>
      </div>
      <div class="phone-nav-content" v-if="modelStatus" @click="toggleModel">
        <ul v-if="!twoBoxStatus">
          <li class="item active" @click="goTo('Home')">HOME</li>
          <li class="item right-arrow" @click.stop="twoBox">OUR PRODCTS</li>
          <li class="item" @click="goTo('Story')">{{lang=='en'?'STORY & HISTORY':'STORIA'}}</li>
          <li class="item" @click="goTo('Contact')">  {{lang=='en'?'CONTACT US':'CONTATTACI'}}</li>
          <li class="langp" @click="langFn">
            <span :class="{langActive:lang=='en'}">EN</span>/<span class="IT" :class="{langActive:lang!='en'}">IT</span>
          </li>
        </ul>
        <div class="titleBack " v-if="twoBoxStatus" @click.stop="goBack">
          <div class="back" style="width: 0.32rem;height: .32rem">
            <img style="width: 100%;height: 100%" src="../assets/back.png" alt="">
          </div>
         <div class="titleText" style="font-size: 1rem;color: #231815;margin-top: .5rem" v-if="lang=='en'">
            <p>OUR</p>
            <p>PRODUCTS</p>
          </div> <div class="titleText" style="font-size: 1rem;color: #231815;margin-top: .5rem" v-if="lang=='it'">
            <p>NOSTRI</p>
            <p>PRODOTTI</p>
          </div>
        </div>
        <ul class="two" v-if="twoBoxStatus">
          <li class="item" @click="goTo('Bodys')">{{lang=='en'?'BODY LOTION':'CREMA CORPO'}}</li>
          <li class="item" @click="goTo('Sham')">SHAMPOO</li>
          <li class="item" @click="goTo('Bath')">{{lang=='en'?'BATH & SHOWER GEL':'BAGNO DOCCIA'}}</li>
        </ul>
      </div>
      <div class="click_box" @click="toggleModel">
        <div class="top_flag"></div>
        <div class="bottom_flag"></div>
      </div>
      <div class="lang"  :class=" {lang_top:scrollTop}" @click="langFn">
        <span :class="{langActive:lang=='en'}">EN</span>/<span class="IT" :class="{langActive:lang!='en'}">IT</span>
      </div>
    </div>
    <div class="main_content">
      <div class="banner_box"></div>
      <div class="productDetail main_item">
        <div class="top_box ">
          <div class="left">
            <div class="title">
              <p>{{productData.name}}</p>
              <p>{{productData.name1}}</p>
              <p>{{productData.name2}}</p>
            </div>
            <div class="message">
              {{productData.textContent}}
            </div>
            <div class="spec">{{productData.spc}}</div>
          </div>
          <div class="right">
            <img :src="productData.packageUrl" alt="">
          </div>
          <div class="clear"></div>
        </div>
        <div class="model_box">
          <div class="img_box" :style="{backgroundImage:'url('+productData.image+')'}"></div>
          <div class="text_box">
            <div class="textLeft" v-if="lang=='en'">
              <p>HOW TO</p>
              <p>USE</p>
            </div>
            <div class="textLeft" v-if="lang=='it'">
              <p>MODO</p>
              <p>D'USO</p>
            </div>
            <div class="textRight">
             {{productData.UseFn}}
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <div class="bottom_box">
          <div class="leftBox" :style="{backgroundImage:'url('+productData.productImage+')'}"></div>
          <div class="rightBox">
            <div class="title"> {{lang=='en'?'INGREDIENTS':'INGREDIENTI'}}</div>
            <div class="message">
             {{productData.INGREDIENTI}}
            </div>
            <div class="messageText">
              <!--<p>Produced and packed by E.Cos ecologia e</p>-->
              <!--<p>cosmesi s.c. Via Barletta, 7 40059 Medicina(BO) Italy.</p>-->
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
      <div class="phone_productDetail main_item">
        <div class="topBox">
          <div class="title_box">
            <p>{{productData.name}}</p>
            <p>{{productData.name1}}</p>
            <p>{{productData.name2}}</p>
          </div>
          <div class="text_box">
            {{productData.textContent}}
          </div>
          <div class="spec">{{productData.spc}}</div>
          <div class="img_box"> <img :src="productData.packageUrl" alt=""></div>
        </div>
        <div class="modeBox">
          <div class="text_box">
            <div class="textLeft">
              <p>HOW TO</p>
              <p>USE</p>
            </div>
            <div class="textRight">
              {{productData.UseFn}}
            </div>
          </div>
          <div class="img_box">
            <div class="img_box" :style="{backgroundImage:'url('+productData.image+')'}"></div>
          </div>
        </div>
        <div class="bottomBox">
          <div class="rightBox">
            <div class="title">INGREDIENT</div>
            <div class="message">
              {{productData.INGREDIENTI}}
            </div>
          </div>
          <div class="img_box" :style="{backgroundImage:'url('+productData.productImage+')'}"></div>
          <div class="messageText">
            <!--<p>Produced and packed by E.Cos ecologia e</p>-->
            <!--<p>cosmesi s.c. Via Barletta, 7 40059 Medicina(BO) Italy.</p>-->
          </div>
        </div>
      </div>
    </div>
    <myFooter></myFooter>
  </div>
</template>
<style scoped lang="scss">
  .content {
    width: 100%;
    position: relative;

    .clear {
      clear: both;
    }

    .nav {
      width: 100%;
      height: 80px;
      display: flex;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
      justify-content: space-around;
      align-items: center;
      box-sizing: border-box;
      margin: 0 auto;
      z-index: 1;
      font-family: CantoriaMT;
      background-color: #000000;

      .logo_box {
        height: 53px;
        width: 60px;
      }

      .nav_content {
        height: 80px;
        box-sizing: border-box;

        .item {
          display: inline-block;

          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #666666;
          margin-right: 78px;
          line-height: 80px;
          position: relative;

          .our {
            position: absolute;
            top: 80px;
            left: -80px;
            width: 260px;
            height: 191px;
            background-color: #ffffff;
            box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06);
            color: #999999;
            box-sizing: border-box;
            font-size: 14px;
            padding: 40px 43px 0;
            display: none;

            div {
              display: block;
              /*margin-bottom: 30px;*/
              height: 50px;
              line-height: 0px;
            }

            .ourActive {

              border-bottom: 1px solid #231815;
              color: #231815;
            }

          }

        }

        .navActive {
          color: #ffffff;
          border-bottom: 1px solid #FFFFFF;
        }

        .ours:hover .our {
          display: block;
        }
      }
      .lang{
        color:#666666;
        .langActive{
          color: #ffffff;
        }
      }
      .lang_top{
        color:#999999;
        .langActive{
          color: #000;
        }
      }
      .click_box {
        display: none;
        height: 30px;
        width: 30px;

        div {
          border-bottom: 1px solid #FFF;
          width: 30px;
          margin-top: 10px;
        }
      }
    }

    .nav_top {
      height: 80px;
      background-color: #ffffff;
      line-height: 80px;

      .nav_content {
        line-height: 80px;

        .item {
          /*line-height: 80px;*/
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #999999;

          .our {
            top: 70px;
          }
        }

        .navActive {
          border-bottom: 1px solid #231815;
          color: #231815;
        }

      }


    }

    .banner_box {
      position: relative;
      width: 100%;
      height: 400px;
      background: url("../assets/banner-2.png") no-repeat center;
      background-size: cover;
      overflow: hidden;
      display: none;
    }

    .main_content {
      .main_item {
        width: 1200px;
        margin: 0 auto;
        /*display: none;*/
      }
      .productDetail{
        display: block;
        .top_box {
          margin-top: 160px;

          .left {
            width: 600px;
            height: 720px;
            font-family: CantoriaMT;
            float: left;
            box-sizing: border-box;

            .title {
              font-size: 40px;
              color: #231815;
              width: 400px;
              margin-top: 319px;
            }

            .message {
              width: 308px;
              height: 138px;
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 24px;
              letter-spacing: 0px;
              color: #9b9b9b;
              font-family: Konnect-Regular;
              margin-top: 14px;
            }

            .spec {
              width: 46px;
              height: 19px;
              font-family: Helvetica;
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 1px;
              color: #231815;
              margin-top: 116px;
            }
          }

          .right {
            float: right;
            width: 600px;
            height: 720px;

            img {
              width: 100%;
              height: 100%;
              border: none;
              box-shadow: none;
              display: inline-block;
            }
          }
        }

        .model_box {
          margin-top: 160px;

          .img_box {
            background: url("../assets/123.png") center no-repeat;
            background-size: cover;
            width: 100%;
            height: 560px;
          }

          .text_box {
            margin-top: 56px;
            font-size: 40px;
            color: #231815;

            .textLeft {
              float: left;
              width: 600px;
              font-family: CantoriaMT;
            }

            .textRight {
              float: left;
              font-size: 14px;
              color: #9b9b9b;
              display: inline-block;
              width: 600px;
              line-height: 24px;
              font-family: Konnect-Regular;
            }
          }
        }

        .bottom_box {
          margin-top: 160px;

          .leftBox {
            width: 720px;
            height: 720px;
            background: url("../assets/product-4.png") center no-repeat;
            background-size: cover;
            float: left;

          }

          .rightBox {
            width: 480px;
            height: 720px;
            float: left;
            text-align: right;
            position: relative;

            .title {
              height: 48px;
              font-family: CantoriaMT;
              font-size: 40px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #231815;
              margin-top: 136px;
            }

            .message {
              margin-top: 14px;
              width: 250px;
              height: 354px;
              font-family: Konnect-Regular;
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 24px;
              letter-spacing: 0px;
              color: #9b9b9b;
              position: absolute;
              right: 0;
              top: 198px;
            }

            .messageText {
              height: 38px;
              font-family: Helvetica;
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 1px;
              color: #231815;
              text-align: right;
              position: absolute;
              bottom: 0;
              right: 0;
            }
          }
        }
      }
      .phone_productDetail{
        display: none;
      }

    }
  }
  @media screen and (max-width: 900)  {
    .content {
      width: 100%;
      position: absolute;
      .nav {
        width: 100%;
        height: 0.88rem;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        padding: 0 .3rem;
        align-items: center;
        box-sizing: border-box;
        font-family: CantoriaMT;

        .logo_box {
          height: 0.53rem;
          width: 0.6rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .nav_content {
          display: none;

          .item {
            display: inline-block;
            font-size: 0.14rem;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #666666;
            margin-right: 78px;
          }
        }

        .phone-nav-content {
          display: block;
          background-color: #fff;
          position: fixed;
          left: 0;
          right: 0;
          top: 0.88rem;
          bottom: 0;
          padding: 0.78rem 0.4rem;

          ul {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            animation: mymove 1s;
            position: absolute;
            top: 0.78rem;
            padding-left: 0.4rem;
            @keyframes mymove {
              from {
                left: 0;
              }
              to {
                left: .4rem;
              }
            }

            @-webkit-keyframes mymove /*Safari and Chrome*/
            {
              from {
                left: 0;
              }
              to {
                left: .4rem;
              }
            }

            .item {
              height: .36rem;
              font-size: .40rem;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #999999;
              margin-top: 1.20rem;
              line-height: 0.36rem;
            }
            .right-arrow{
              background: url("../assets/right-arrow.png") no-repeat center right;
              background-size: .32rem .32rem;
              width: 4.5rem;
            }

            .back {

            }

            .active {
              border-bottom: 0.01rem solid #999999;
            }
          }

          ul.two {
            top: 4.75rem;
            padding-left: 0;

            .item {
              font-size: .32rem;
              margin-top: 0.6rem;

            }
          }
        }
        .langp {
          font-size: .3rem;
          color: #999999;
          margin-top: .4rem;

          .langActive {
            color: black;
            font-weight: bold;
          }
        }
        .click_box {
          height: 0.32rem;
          width: 0.32rem;
          display: block;

          div {
            border-bottom: 0.02rem solid #FFF;
            width: 0.32rem;
            margin-top: 0.1rem;
          }
        }
        .lang{
          display: none;
        }
      }
      .nav.nav_top {
        background-image: none;
        background-color: #fff;

        .click_box {
          div {
            border-bottom: 0.02rem solid black;
          }
        }
        .lang{
          display: none;
        }
      }
      .banner_box {
        display: none;
        position: relative;
        width: 100%;
        height: 5.4rem;
        background: url("../assets/banner-2.png") no-repeat center;
        background-size: cover;
        overflow: hidden;
      }
      .main_content {
        .main_item {
          width: 6.9rem;
          margin: 0 auto;
          /*display: none;*/
        }
        .productDetail{
          display: none;
        }
        .phone_productDetail{
          display: block;
          font-family: CantoriaMT;
          margin-top: 1.2rem;
          .topBox{
            margin-top: 2rem;
            .title_box{
              font-size: .5rem;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #231815;
            }
            .text_box{
              font-size: .24rem;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #9b9b9b;
              font-family: Konnect-Regular;
              margin-top: .3rem;
              line-height: .36rem;
            }
            .spec{
              font-size: .20rem;
              font-weight: normal;
              font-stretch: normal;
              color: #231815;
              margin-top: 1.2rem;
              font-family: Konnect-Bold;
            }
            .img_box{
              width: 6.9rem;
              height: 8.28rem;
              margin-top:.8rem ;
              img{
                width: 100%;
                height: 100%;
              }
            }
          }
          .modeBox{
            margin-top: 1.2rem;
            .text_box{
              font-size: .50rem;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #231815;
              .textRight{
                font-size: .24rem;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #9b9b9b;
                font-family: Konnect-Regular;
                margin-top: .3rem;
                line-height: .36rem;
              }
            }
            .img_box{
              width: 6.9rem;
              height: 3.4rem;
              margin-top: .6rem;
              background: url('') no-repeat center;
              background-size: cover;
            }

          }
          .bottomBox{
            font-family: CantoriaMT;
            margin-top: 1.2rem;
            .rightBox{
              font-size: .5rem;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #231815;
              .message{
                font-size: .24rem;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #9b9b9b;
                font-family: Konnect-Regular;
                margin-top: .3rem;
                line-height: .36rem;
              }
            }
            .img_box{
                width: 6.9rem;
                height: 6.9rem;
                background: url('') no-repeat center ;
                background-size: cover;
              margin-top:.6rem ;
            }
            .messageText{
              font-size: .24rem;
              font-weight: normal;
              letter-spacing: 0px;
              color: #231815;
              margin-top: .6rem;
            }
          }
        }

      }
    }


  }



</style>
<script>
  export default {
    name: 'HelloWorld',
    data() {
      return {
        scrollTop: 0,
        windowWidth: null,
        modelStatus: false,
        pcModelStatus: false,
        curIndex: 0,
        productsList: [
          {
            name: "BODY LOTION1",
            list: [
              {
                name: "MORINGA11",
                names: 'BODY LOTION',
                imgUrl: 'http://cdn.idsdayanjing.com/image_20190320145628_66066.png'
              },
              {
                name: "MORINGA12",
                names: 'BODY LOTION',
                imgUrl: 'http://cdn.idsdayanjing.com/image_20190320145628_66066.png'
              },
              {
                name: "MORINGA13",
                names: 'BODY LOTION',
                imgUrl: 'http://cdn.idsdayanjing.com/image_20190320145628_66066.png'
              },
            ]
          },
          {
            name: "BODY LOTION2",
            list: [
              {
                name: "MORINGA22",
                names: 'BODY LOTION',
                imgUrl: 'http://cdn.idsdayanjing.com/image_20190320145628_66066.png'
              },
              {
                name: "MORINGA23",
                names: 'BODY LOTION',
                imgUrl: 'http://cdn.idsdayanjing.com/image_20190320145628_66066.png'
              },
              {
                name: "MORINGA24",
                names: 'BODY LOTION',
                imgUrl: 'http://cdn.idsdayanjing.com/image_20190320145628_66066.png'
              },
            ]
          },
          {
            name: "BODY LOTION3",
            list: [
              {
                name: "MORINGA33",
                names: 'BODY LOTION',
                imgUrl: 'http://cdn.idsdayanjing.com/image_20190320145628_66066.png'
              },
              {
                name: "MORINGA34",
                names: 'BODY LOTION',
                imgUrl: 'http://cdn.idsdayanjing.com/image_20190320145628_66066.png'
              },
              {
                name: "MORINGA335",
                names: 'BODY LOTION',
                imgUrl: 'http://cdn.idsdayanjing.com/image_20190320145628_66066.png'
              },
            ]
          },
        ],
        twoBoxStatus: false,
        productData: '',
        productType: '',
        productDataType:null,
        lang:'en',
        productDataList:''
      }
    },
    mounted() {
      this.lang=this.defined.lang;
      this.productDataType = this.$route.query.data;
      this.productType = this.$route.query.type;
      this.windowWidth = window.document.documentElement.clientWidth;
      window.addEventListener('scroll', () => {
        const cHeight = document.getElementsByClassName('banner_box')[0].clientHeight
        if (document.documentElement.scrollTop != 0) {
          this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        } else {
          this.scrollTop = 0;
        }

      })
      this.queryData();
    },
    methods: {
      goTo(data, type) {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        if (this.productType && type) {
          this.productType = type;
        } else {
          this.$router.push({path: `/${data}`, query: {type: type}})
        }

      },
      langFn(){
        if(this.defined.lang=='en'){
          this.defined.setLang('it')
          this.lang='it'
          this.productData=this.productDataList[this.defined.lang][`${this.productType}`]
        }else {
          this.defined.setLang('en')
          this.lang='en'
          this.productData=this.productDataList[this.defined.lang][`${this.productType}`]
        }
      },
      queryData() {
        this.$http({
          method: "get",
          url: "/static/data.json",
          dataType: "json",
          crossDomain: true,
          cache: false
        }).then(res=> {
          console.log(res)
            this.productDataList=res.data;
            this.productData=this.productDataList[this.defined.lang][`${this.productType}`]
        }),
          reject => {
            console.log("请求失败", reject);
          };
      },
      toggleModel() {
        if (this.windowWidth <= 1024 && !this.modelStatus) {
          this.modelStatus = true
          this.twoBoxStatus = false
        } else if (this.windowWidth <= 1024 && this.modelStatus) {
          this.modelStatus = false
          this.twoBoxStatus = false
        } else if (this.windowWidth > 1024 && !this.pcModelStatus) {
          this.pcModelStatus = true;
        } else if (this.windowWidth > 1024 && this.pcModelStatus) {
          this.pcModelStatus = false;
        }
      },
      toggleList(index) {
        this.curIndex = index
      },
      twoBox() {
        this.twoBoxStatus = true;
      },
      goBack() {
        this.twoBoxStatus = false;
      }
    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->




// WEBPACK FOOTER //
// src/components/Detail.vue